import { render, staticRenderFns } from "./InputerAggregatorTransaction.vue?vue&type=template&id=f18d73a0"
import script from "./InputerAggregatorTransaction.vue?vue&type=script&lang=js"
export * from "./InputerAggregatorTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports